/* src/app/components/ai-library/ai-library/e-library-details/ai-library-tile/ai-library-tile.component.scss */
.card-body {
  min-height: 50vh;
}
.tabs {
  padding: 0.5rem 0rem;
  margin-bottom: 0rem !important;
}
.tabs ul {
  border-bottom-width: 0px !important;
}
.tabs .doc-views-tabs li.is-active {
  border-bottom: 1px solid var(--primaryColor) !important;
}
.tabs li.tab {
  margin-bottom: 0.5em !important;
}
.tabs.is-boxed a {
  border: none !important;
}
::ng-deep .angular-editor-textarea {
  background: #fff !important;
}
.library_tile_view {
  padding: 7px 0px !important;
}
.library_tile_view .input {
  height: 2rem !important;
  font-size: 0.9rem !important;
}
.library_tile_view .questionnarie {
  width: 97%;
  margin: 1% auto;
  background: #fafafa !important;
}
.library_tile_view .questionnarie .input {
  width: 90% !important;
}
.library_tile_view .question-option .input {
  width: 100% !important;
}
.library_tile_view .question-option .is-checkradio[type=radio] + label,
.library_tile_view .question-option .is-checkradio[type=checkbox] + label {
  padding: 0.2rem 0.8rem !important;
}
.library_tile_view .flex-container .flex-item .card .title {
  margin-bottom: 0.2rem;
  width: 100%;
}
.library_tile_view .flex-container .flex-item .card .title,
.library_tile_view .flex-container .flex-item .card .shared {
  cursor: pointer;
}
.library_tile_view .flex-container .flex-item .card .title,
.library_tile_view .flex-container .flex-item .card label {
  font-size: 0.9rem;
}
.library_tile_view .flex-container .flex-item .card .shared,
.library_tile_view .flex-container .flex-item .card .subtitle {
  color: #a1a1a1;
}
.library_tile_view .flex-container .flex-item .card:hover {
  cursor: pointer;
}
.library_tile_view .flex-container .flex-item .card:hover .button {
  box-shadow: none;
}
.library_tile_view .flex-container .flex-item .card:hover .shareBtnOptions {
  display: block !important;
}
.library_tile_view .flex-container .flex-item .card:hover .fileBtnOptions {
  display: block !important;
}
.library_tile_view .flex-container .flex-item .card:hover .buylesson {
  display: block !important;
}
.library_tile_view .flex-container .flex-item .card .card-image {
  cursor: pointer;
  min-height: 80px !important;
}
.library_tile_view .flex-container .flex-item .card .card-image .thumb_play {
  position: absolute;
  top: 48%;
  left: 45%;
  display: none;
}
.library_tile_view .flex-container .flex-item .card .card-image .thumb_play .fa {
  color: #dcdcdc;
  font-size: 32px !important;
}
.library_tile_view .flex-container .flex-item .card .card-image .tile_imgcenter {
  height: auto;
  display: block;
  width: 80%;
  padding: 10px;
}
.library_tile_view .flex-container .flex-item .card .card-image .videoDuration {
  font-size: 12px;
  position: absolute;
  right: 5px;
  font-weight: 600;
  background: #333;
  color: var(--whiteColor);
  bottom: 10px;
  width: 59px;
  text-align: center;
}
.library_tile_view .flex-container .flex-item .card .card-content,
.library_tile_view .flex-container .flex-item .card .card-body {
  cursor: default !important;
}
.library_tile_view .flex-container .flex-item .card .card-content .questionnaries,
.library_tile_view .flex-container .flex-item .card .card-body .questionnaries {
  border-left: 1px solid #acacac;
}
.library_tile_view .flex-container .flex-item .card .card-content .is-divider-vertical,
.library_tile_view .flex-container .flex-item .card .card-body .is-divider-vertical {
  display: flex;
  flex: none;
  width: auto;
  height: auto;
  padding: 2rem;
  margin: 0;
  position: relative;
  border-top: none;
  min-height: 2rem;
}
.library_tile_view .flex-container .flex-item .card .card-content .is-divider-vertical::before,
.library_tile_view .flex-container .flex-item .card .card-body .is-divider-vertical::before {
  border-left: 3px solid #dbdbdb;
  bottom: 1rem;
  content: "";
  display: block;
  position: absolute;
  top: 1rem;
  -webkit-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
  transform: translateX(-50%);
}
.library_tile_view .flex-container .flex-item .card .card-content .embQuestStyle,
.library_tile_view .flex-container .flex-item .card .card-body .embQuestStyle {
  text-align: left;
  font-size: 16px;
}
.library_tile_view .flex-container .flex-item .card .card-content .responsiveRadioBtn,
.library_tile_view .flex-container .flex-item .card .card-body .responsiveRadioBtn {
  margin: 10px 0px;
}
.library_tile_view .flex-container .flex-item .card .card-content section.section,
.library_tile_view .flex-container .flex-item .card .card-body section.section {
  padding: 1rem 2rem 0rem 0rem;
}
.library_tile_view .flex-container .flex-item .card .card-content section.section .removeAssQuestion,
.library_tile_view .flex-container .flex-item .card .card-body section.section .removeAssQuestion {
  float: right;
  top: -32px;
  text-align: center;
  color: var(--whiteColor);
  cursor: pointer;
  position: relative;
  right: -29px;
}
.library_tile_view .flex-container .flex-item .card .card-content section.section .removeAssQuestion:hover,
.library_tile_view .flex-container .flex-item .card .card-body section.section .removeAssQuestion:hover {
  color: #d62e2e !important;
}
.library_tile_view .flex-container .flex-item .card .card-content .title,
.library_tile_view .flex-container .flex-item .card .card-body .title {
  font-size: 14px !important;
  margin-bottom: 4px;
  white-space: nowrap;
  width: 121px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.library_tile_view .flex-container .flex-item .card .card-content .description,
.library_tile_view .flex-container .flex-item .card .card-body .description {
  font-size: 12px !important;
  color: #000 !important;
  margin-bottom: 4px;
  white-space: nowrap;
  width: 121px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.library_tile_view .flex-container .flex-item .card .card-content .shareBtnOptions,
.library_tile_view .flex-container .flex-item .card .card-body .shareBtnOptions {
  position: relative;
  top: -15px;
  line-height: 1;
}
.library_tile_view .flex-container .flex-item .card .card-content .fileBtnOptions,
.library_tile_view .flex-container .flex-item .card .card-body .fileBtnOptions {
  position: relative;
  top: -25px;
  right: -15px;
  line-height: 1;
}
.library_tile_view .flex-container .flex-item .card .card-content .fileBtnOptions .dropdown .dropdown-menu,
.library_tile_view .flex-container .flex-item .card .card-body .fileBtnOptions .dropdown .dropdown-menu {
  min-width: 6rem;
}
.library_tile_view .flex-container .flex-item .card .card-content .fileBtnOptions .dropdown .dropdown-menu .dropdown-item .fa,
.library_tile_view .flex-container .flex-item .card .card-body .fileBtnOptions .dropdown .dropdown-menu .dropdown-item .fa {
  font-size: 12px !important;
  margin-right: 5px;
  margin-top: 5px;
}
.library_tile_view .flex-container .flex-item .card .card-content .fileBtnOptions .dropdown .dropdown-menu hr,
.library_tile_view .flex-container .flex-item .card .card-body .fileBtnOptions .dropdown .dropdown-menu hr {
  margin: 0px;
}
.library_tile_view .flex-container .flex-item .card .card-content .fileBtnOptions .dropdown .dropdown-trigger,
.library_tile_view .flex-container .flex-item .card .card-body .fileBtnOptions .dropdown .dropdown-trigger {
  position: relative;
  top: 8px;
  right: 5px;
}
.library_tile_view .flex-container .flex-item .card .card-content .fileBtnOptions .hiddenDownloadLink,
.library_tile_view .flex-container .flex-item .card .card-body .fileBtnOptions .hiddenDownloadLink {
  display: none;
}
.library_tile_view .flex-container .flex-item .card .card-content .fileBtnOptions a,
.library_tile_view .flex-container .flex-item .card .card-body .fileBtnOptions a {
  color: #000;
}
.library_tile_view .flex-container .flex-item .card .card-content .fileBtnOptions a:hover,
.library_tile_view .flex-container .flex-item .card .card-body .fileBtnOptions a:hover {
  color: var(--primaryColor);
}
.library_tile_view .flex-container .flex-item .card .card-content .fileBtnOptions .hiddenDownloadLink,
.library_tile_view .flex-container .flex-item .card .card-body .fileBtnOptions .hiddenDownloadLink {
  pointer-events: none;
}
.library_tile_view .flex-container .flex-item .card .card-content .shared,
.library_tile_view .flex-container .flex-item .card .card-body .shared {
  margin-bottom: 2px;
  font-size: 13px;
  color: #ccc;
  text-transform: capitalize;
}
.library_tile_view .flex-container .flex-item .card .card-content .subtitle,
.library_tile_view .flex-container .flex-item .card .card-body .subtitle {
  margin-bottom: 2px;
  font-size: 13px;
  color: #ccc;
}
.library_tile_view .flex-container .flex-item .card .card-content .price-text--container--Ws-fP,
.library_tile_view .flex-container .flex-item .card .card-body .price-text--container--Ws-fP {
  align-items: center;
  color: #3c3b37;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.library_tile_view .flex-container .flex-item .card .card-content .price-text--container--Ws-fP .price-text--price-part--Tu6MH,
.library_tile_view .flex-container .flex-item .card .card-body .price-text--container--Ws-fP .price-text--price-part--Tu6MH {
  line-height: 1;
  padding: 0.4rem 0;
  margin-right: 0.8rem;
  white-space: nowrap;
}
.library_tile_view .flex-container .flex-item .card .card-content .price-text--container--Ws-fP .price-text--price-part--Tu6MH:last-child,
.library_tile_view .flex-container .flex-item .card .card-body .price-text--container--Ws-fP .price-text--price-part--Tu6MH:last-child {
  margin-right: 0;
}
.library_tile_view .flex-container .flex-item .card .card-content .price-text--container--Ws-fP .price-text--original-price--2e-F5,
.library_tile_view .flex-container .flex-item .card .card-body .price-text--container--Ws-fP .price-text--original-price--2e-F5 {
  color: #73726c;
}
.library_tile_view .flex-container .flex-item .card .card-content .price-text--container--Ws-fP .udlite-sr-only,
.library_tile_view .flex-container .flex-item .card .card-body .price-text--container--Ws-fP .udlite-sr-only {
  position: absolute !important;
  height: 1px;
  width: 1px;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
}
.library_tile_view .flex-container .flex-item .card .card-content .btn_buylesson,
.library_tile_view .flex-container .flex-item .card .card-body .btn_buylesson {
  float: right;
  position: absolute;
  right: 10px;
  line-height: 2.2;
  bottom: 20px;
}
.library_tile_view .flex-container .flex-item .card .card-content .btn_buylesson .button,
.library_tile_view .flex-container .flex-item .card .card-body .btn_buylesson .button {
  margin-left: 10px;
}
.library_tile_view .flex-container .flex-item .card .card-content .switch[type=checkbox],
.library_tile_view .flex-container .flex-item .card .card-body .switch[type=checkbox] {
  outline: 0;
  -webkit-user-select: none;
  user-select: none;
  display: inline-block;
  position: absolute;
  opacity: 0;
}
.library_tile_view .flex-container .flex-item .card .card-content .switch[type=checkbox] .is-rtl + label,
.library_tile_view .flex-container .flex-item .card .card-body .switch[type=checkbox] .is-rtl + label {
  padding-left: 0;
  padding-right: 3.5rem;
}
.library_tile_view .flex-container .flex-item .card .card-content .switch[type=checkbox] + label,
.library_tile_view .flex-container .flex-item .card .card-body .switch[type=checkbox] + label {
  position: relative;
  display: initial;
  font-size: 1rem;
  line-height: initial;
  padding-left: 3.5rem;
  padding-top: 0.2rem;
  cursor: pointer;
}
.library_tile_view .flex-container .flex-item .card .card-content .switch[type=checkbox]:checked + label::before,
.library_tile_view .flex-container .flex-item .card .card-body .switch[type=checkbox]:checked + label::before {
  background: #00d1b2;
}
.library_tile_view .flex-container .flex-item .card .card-content .questionnarie,
.library_tile_view .flex-container .flex-item .card .card-body .questionnarie {
  margin-bottom: 20px;
  padding: 0rem 1.5rem !important;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
}
.library_tile_view .flex-container .flex-item .card .card-content .questionnarie .questionariesTabul,
.library_tile_view .flex-container .flex-item .card .card-body .questionnarie .questionariesTabul {
  font-size: 15px;
}
.library_tile_view .flex-container .flex-item .card .card-content .questionnarie .question-choice,
.library_tile_view .flex-container .flex-item .card .card-body .questionnarie .question-choice {
  padding: 1rem 0rem 1rem 0rem;
}
.library_tile_view .flex-container .flex-item .card .card-content .questionnarie .questionOption,
.library_tile_view .flex-container .flex-item .card .card-body .questionnarie .questionOption {
  padding: 0rem 0rem !important;
}
.library_tile_view .flex-container .flex-item .card .card-content .questionnarie .question-option .control,
.library_tile_view .flex-container .flex-item .card .card-body .questionnarie .question-option .control {
  margin-bottom: 10px;
  width: 90%;
}
.library_tile_view .flex-container .flex-item .card .card-content .questionnarie .question-option .control ul .editQuizContent,
.library_tile_view .flex-container .flex-item .card .card-body .questionnarie .question-option .control ul .editQuizContent {
  margin-left: 0em !important;
}
.library_tile_view .flex-container .flex-item .card .card-content .questionnarie .question-option .control .removeOptions,
.library_tile_view .flex-container .flex-item .card .card-body .questionnarie .question-option .control .removeOptions {
  float: right;
  top: 5px;
  width: 30px;
  height: 30px;
  text-align: center;
  color: var(--whiteColor);
  cursor: pointer;
  position: absolute;
  right: -69px;
}
.library_tile_view .flex-container .flex-item .card .card-content .questionnarie .question-option .control .removeOptions:hover,
.library_tile_view .flex-container .flex-item .card .card-body .questionnarie .question-option .control .removeOptions:hover {
  color: #d62e2e !important;
}
.library_tile_view .flex-container .flex-item .card .card-content .questionnarie .question-option .control .is-checkradio[type=radio],
.library_tile_view .flex-container .flex-item .card .card-content .questionnarie .question-option .control .is-checkradio[type=checkbox],
.library_tile_view .flex-container .flex-item .card .card-body .questionnarie .question-option .control .is-checkradio[type=radio],
.library_tile_view .flex-container .flex-item .card .card-body .questionnarie .question-option .control .is-checkradio[type=checkbox] {
  outline: 0;
  -webkit-user-select: none;
  user-select: none;
  display: inline-block;
  position: absolute;
  opacity: 0;
}
.library_tile_view .flex-container .flex-item .card .card-content .questionnarie .question-option .control .is-checkradio[type=radio] + label:first-of-type,
.library_tile_view .flex-container .flex-item .card .card-content .questionnarie .question-option .control .is-checkradio[type=checkbox] + label:first-of-type,
.library_tile_view .flex-container .flex-item .card .card-body .questionnarie .question-option .control .is-checkradio[type=radio] + label:first-of-type,
.library_tile_view .flex-container .flex-item .card .card-body .questionnarie .question-option .control .is-checkradio[type=checkbox] + label:first-of-type {
  float: right;
  position: absolute;
  margin-left: 10px;
}
.library_tile_view .flex-container .flex-item .card .card-content .questionnarie .question-option .control .is-checkradio[type=radio]:checked + label::before,
.library_tile_view .flex-container .flex-item .card .card-content .questionnarie .question-option .control .is-checkradio[type=radio]:checked + label:before,
.library_tile_view .flex-container .flex-item .card .card-content .questionnarie .question-option .control .is-checkradio[type=checkbox]:checked + label::before,
.library_tile_view .flex-container .flex-item .card .card-content .questionnarie .question-option .control .is-checkradio[type=checkbox]:checked + label:before,
.library_tile_view .flex-container .flex-item .card .card-body .questionnarie .question-option .control .is-checkradio[type=radio]:checked + label::before,
.library_tile_view .flex-container .flex-item .card .card-body .questionnarie .question-option .control .is-checkradio[type=radio]:checked + label:before,
.library_tile_view .flex-container .flex-item .card .card-body .questionnarie .question-option .control .is-checkradio[type=checkbox]:checked + label::before,
.library_tile_view .flex-container .flex-item .card .card-body .questionnarie .question-option .control .is-checkradio[type=checkbox]:checked + label:before {
  animation-name: none;
  border: 0.1rem solid #dbdbdb;
}
.library_tile_view .flex-container .flex-item .card .card-content .questionnarie .question-option .control .is-checkradio[type=radio]:checked + label::after,
.library_tile_view .flex-container .flex-item .card .card-content .questionnarie .question-option .control .is-checkradio[type=radio]:checked + label:after,
.library_tile_view .flex-container .flex-item .card .card-content .questionnarie .question-option .control .is-checkradio[type=checkbox]:checked + label::after,
.library_tile_view .flex-container .flex-item .card .card-content .questionnarie .question-option .control .is-checkradio[type=checkbox]:checked + label:after,
.library_tile_view .flex-container .flex-item .card .card-body .questionnarie .question-option .control .is-checkradio[type=radio]:checked + label::after,
.library_tile_view .flex-container .flex-item .card .card-body .questionnarie .question-option .control .is-checkradio[type=radio]:checked + label:after,
.library_tile_view .flex-container .flex-item .card .card-body .questionnarie .question-option .control .is-checkradio[type=checkbox]:checked + label::after,
.library_tile_view .flex-container .flex-item .card .card-body .questionnarie .question-option .control .is-checkradio[type=checkbox]:checked + label:after {
  display: inline-block;
}
.library_tile_view .flex-container .flex-item .card .card-content .questionnarie .survey_question .is-checkradio[type=radio],
.library_tile_view .flex-container .flex-item .card .card-content .questionnarie .survey_question .is-checkradio[type=checkbox],
.library_tile_view .flex-container .flex-item .card .card-body .questionnarie .survey_question .is-checkradio[type=radio],
.library_tile_view .flex-container .flex-item .card .card-body .questionnarie .survey_question .is-checkradio[type=checkbox] {
  outline: 0;
  -webkit-user-select: none;
  user-select: none;
  display: inline-block;
  position: absolute;
  opacity: 0;
}
.library_tile_view .flex-container .flex-item .card .card-content .questionnarieAns,
.library_tile_view .flex-container .flex-item .card .card-body .questionnarieAns {
  padding: 2rem 0rem;
  margin-top: -7%;
}
.library_tile_view .flex-container .flex-item .card .card-content .switch[type=checkbox],
.library_tile_view .flex-container .flex-item .card .card-body .switch[type=checkbox] {
  outline: 0;
  -webkit-user-select: none;
  user-select: none;
  display: inline-block;
  position: absolute;
  opacity: 0;
}
.library_tile_view .flex-container .flex-item .card .card-content .switch[type=checkbox].is-small + label,
.library_tile_view .flex-container .flex-item .card .card-body .switch[type=checkbox].is-small + label {
  position: relative;
  display: initial;
  font-size: 1rem;
  line-height: initial;
  padding-left: 0;
  padding-right: 3.5rem;
  cursor: pointer;
  font-weight: normal;
}
.library_tile_view .flex-container .flex-item .card .card-content .switch[type=checkbox].is-success:checked + label::before,
.library_tile_view .flex-container .flex-item .card .card-content .switch[type=checkbox].is-success:checked + label:before,
.library_tile_view .flex-container .flex-item .card .card-body .switch[type=checkbox].is-success:checked + label::before,
.library_tile_view .flex-container .flex-item .card .card-body .switch[type=checkbox].is-success:checked + label:before {
  background: var(--primaryColor);
}
.library_tile_view .flex-container .flex-item .card .card-content .switch[type=checkbox].is-sucess + label::before,
.library_tile_view .flex-container .flex-item .card .card-content .switch[type=checkbox].is-success + label:before,
.library_tile_view .flex-container .flex-item .card .card-body .switch[type=checkbox].is-sucess + label::before,
.library_tile_view .flex-container .flex-item .card .card-body .switch[type=checkbox].is-success + label:before {
  left: auto;
  right: -0.375rem;
}
.library_tile_view .flex-container .flex-item .card .card-content .switch[type=checkbox] + label::before,
.library_tile_view .flex-container .flex-item .card .card-content .switch[type=checkbox] + label:before,
.library_tile_view .flex-container .flex-item .card .card-body .switch[type=checkbox] + label::before,
.library_tile_view .flex-container .flex-item .card .card-body .switch[type=checkbox] + label:before {
  position: absolute;
  display: block;
  top: 0;
  left: auto;
  right: 0.25rem;
  width: 3rem;
  height: 1.5rem;
  border: 0.1rem solid transparent;
  border-radius: 4px;
  background: #b5b5b5;
  content: "";
}
.library_tile_view .flex-container .flex-item .card .card-content .switch[type=checkbox].is-success + label::after,
.library_tile_view .flex-container .flex-item .card .card-content .switch[type=checkbox].is-success + label:after,
.library_tile_view .flex-container .flex-item .card .card-body .switch[type=checkbox].is-success + label::after,
.library_tile_view .flex-container .flex-item .card .card-body .switch[type=checkbox].is-success + label:after {
  display: block;
  position: absolute;
  top: 0.25rem;
  left: auto;
  right: 1.425rem;
  width: 1rem;
  height: 1rem;
  transform: translate3d(0, 0, 0);
  border-radius: 4px;
  background: var(--whiteColor);
  transition: all 0.25s ease-out;
  content: "";
}
.library_tile_view .flex-container .flex-item .card .card-content .switch[type=checkbox]:checked.is-success + label::after,
.library_tile_view .flex-container .flex-item .card .card-content .switch[type=checkbox]:checked.is-success + label:after,
.library_tile_view .flex-container .flex-item .card .card-body .switch[type=checkbox]:checked.is-success + label::after,
.library_tile_view .flex-container .flex-item .card .card-body .switch[type=checkbox]:checked.is-success + label:after {
  left: auto;
  right: 0;
}
.library_tile_view .flex-container .flex-item .card .card-footer .lessonPublish {
  width: 100% !important;
  margin-left: 26px;
}
.library_tile_view .flex-container .flex-item .card .card-footer .lessonPublish .responsiveRadioBtn {
  margin: 20px 0;
}
.library_tile_view .flex-container .flex-item .card .card-footer .lessonPublish .switch[type=checkbox] + label {
  position: relative;
  display: initial;
  font-size: 1rem;
  line-height: initial;
  padding-left: 0;
  padding-right: 3.5rem;
  cursor: pointer;
  font-weight: bold;
}
.library_tile_view .flex-container .flex-item .card .card-footer .lessonPublish .switch[type=checkbox] + label::before {
  position: absolute;
  display: block;
  top: 0;
  left: auto;
  right: -0.375rem;
  width: 3rem;
  height: 1.5rem;
  border: 0.1rem solid transparent;
  border-radius: 4px;
  background: #b5b5b5;
  content: "";
}
.library_tile_view .flex-container .flex-item .card .card-footer .lessonPublish .switch[type=checkbox].is-success + label:after {
  display: block;
  position: absolute;
  top: 0.25rem;
  left: auto;
  right: 1.425rem;
  width: 1rem;
  height: 1rem;
  transform: translate3d(0, 0, 0);
  border-radius: 4px;
  background: var(--whiteColor);
  transition: all 0.25s ease-out;
  content: "";
}
.library_tile_view .flex-container .flex-item .card .card-footer .lessonSubmitBtn {
  position: absolute;
  top: 5px;
  right: 0px;
}
.library_tile_view .flex-container .flex-item .card .card-footer .actBtnMobileView {
  display: none;
}
.library_tile_view .flex-container .flex-item .card .card-header .card-header-title {
  font-size: 19px !important;
}
.library_tile_view .flex-container .flex-item .card .buylesson {
  position: absolute;
  top: 0px;
  z-index: 9;
  height: 50px;
  display: none;
  font-size: 15px;
  bottom: 0px;
}
.library_tile_view .editedFileUpload .card .card-content {
  overflow-y: auto;
  max-height: calc(100vh - 253px);
}
.modal-card {
  width: calc(100% - 20px);
}
.modal-card-title {
  font-size: 1.2rem;
}
.modal-content-body {
  position: relative;
  margin: 0 auto;
  max-height: calc(100vh - 40px);
  width: calc(100% - 100px);
}
.modal-content-body .modal-card-body {
  max-height: calc(100vh - 200px);
  overflow: auto;
  min-height: 50vh;
  background: hsl(0, 0%, 98%);
}
.modal-card-head {
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  background: var(--popupwindowheadbg);
}
.modal-card-head p {
  color: #fff;
}
.modal-card-foot {
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
  justify-content: end;
  min-height: 50px;
}
.modal-card-foot .button.is-link {
  background: var(--popupwindowheadbg) !important;
}
.policy-upload .modal-dialog {
  max-width: calc(100vw - 50px) !important;
}
.policy-upload .modal-dialog .modal-content {
  width: 100% !important;
}
.policy-upload .modal-dialog .modal-body {
  padding: 0px !important;
}
.policy-upload .modal-dialog ::ng-deep .card {
  box-shadow: none !important;
}
.policy-upload .modal-dialog ::ng-deep .card .card-body {
  min-height: calc(100vh - 300px) !important;
}
.modal-dialog .modal-content {
  max-width: calc(100vw - 50px);
}
.modal-dialog .modal-header {
  justify-content: space-between;
}
.modal-dialog .modal-body {
  max-height: calc(100vh - 150px);
  overflow-y: auto;
  scrollbar-width: none;
}
.modal-dialog .fa-solid {
  font-size: 1.5rem !important;
  color: #fff !important;
}
.modal-dialog .btn-primary {
  background: var(--primaryColor) !important;
  color: #fff !important;
}
.modal-dialog .btn-cancel {
  background-color: #eee;
  color: #111;
}
.modal-dialog .btn {
  padding: 0.3rem 0.8rem !important;
}
.modal.fade {
  background: rgba(0, 0, 0, 0.2);
}
.modal.show {
  display: block;
}
.modal-header {
  background: var(--primaryColor);
  color: #fff;
}
@media screen and (max-width: 320px) and (max-width: 767px) {
  .library_tile_view .flex-container .flex-item .card .card-footer .actBtnDeskView {
    display: none;
  }
  .library_tile_view .flex-container .flex-item .card .card-footer .actBtnMobileView {
    display: block;
    float: right;
  }
  .library_tile_view .flex-item {
    width: 319px;
  }
  .library_tile_view .flex-item .responsiveRadioBtn {
    margin: 20px 0;
  }
  .library_tile_view .flex-item .questionnarieMobile {
    margin-top: 10px;
  }
  .library_tile_view .flex-item .card .card-content .questionnarie .question-option .control,
  .library_tile_view .flex-item .card .card-body .questionnarie .question-option .control {
    width: 176px;
  }
  .library_tile_view .flex-item .card .card-content .questionnarie .question-option .control .is-checkradio[type=radio].is-danger + label::before,
  .library_tile_view .flex-item .card .card-content .questionnarie .question-option .control .is-checkradio[type=radio].is-danger + label:before,
  .library_tile_view .flex-item .card .card-body .questionnarie .question-option .control .is-checkradio[type=radio].is-danger + label::before,
  .library_tile_view .flex-item .card .card-body .questionnarie .question-option .control .is-checkradio[type=radio].is-danger + label:before {
    border: 3px solid #f14668;
  }
  .library_tile_view .flex-item .card .card-content .interactiveScroll .is-divider-vertical,
  .library_tile_view .flex-item .card .card-body .interactiveScroll .is-divider-vertical {
    display: block;
    flex: none;
    width: auto;
    height: auto;
    padding: 2rem;
    margin: 0;
    position: relative;
    border-top: none;
    min-height: 2rem;
  }
  .library_tile_view .flex-item .card .card-content .interactiveScroll .is-divider-vertical::before,
  .library_tile_view .flex-item .card .card-body .interactiveScroll .is-divider-vertical::before {
    border-left: 0.1rem solid #dbdbdb;
    bottom: 1rem;
    content: "";
    display: block;
    left: 50%;
    position: absolute;
    top: 1rem;
    -webkit-transform: translateX(-50%);
    -ms-transform: translateX(-50%);
    transform: translateX(-50%);
  }
  .library_tile_view .flex-item .card .card-footer .lessonPublish {
    width: 100% !important;
    margin-left: 26px;
  }
  .library_tile_view .flex-item .card .card-footer .lessonPublish .responsiveRadioBtn {
    margin: 20px 0;
  }
  .library_tile_view .flex-item .card .card-footer .lessonPublish .switch[type=checkbox] + label {
    position: relative;
    display: initial;
    font-size: 1rem;
    line-height: initial;
    padding-left: 0;
    padding-right: 3.5rem;
    cursor: pointer;
    font-weight: bold;
  }
  .library_tile_view .flex-item .card .card-footer .lessonPublish .switch[type=checkbox] + label::before {
    position: absolute;
    display: block;
    top: 0;
    left: auto;
    right: -0.375rem;
    width: 3rem;
    height: 1.5rem;
    border: 0.1rem solid transparent;
    border-radius: 4px;
    background: #b5b5b5;
    content: "";
  }
  .library_tile_view .flex-item .card .card-footer .lessonPublish .switch[type=checkbox].is-success + label:after {
    display: block;
    position: absolute;
    top: 0.25rem;
    left: auto;
    right: 1.425rem;
    width: 1rem;
    height: 1rem;
    transform: translate3d(0, 0, 0);
    border-radius: 4px;
    background: var(--whiteColor);
    transition: all 0.25s ease-out;
    content: "";
  }
  .library_tile_view .flex-item .card .card-footer .lessonSubmitBtn {
    position: absolute;
    top: 5px;
    right: 0px;
  }
}
/*# sourceMappingURL=ai-library-tile.component.css.map */
